import { createLazyFileRoute } from "@tanstack/react-router";

import { NewPrinterPage } from "@/features/admin/routes/PrinterNew";

export const Route = createLazyFileRoute("/_auth/admin/printers/new")({
  component: NewPrinterPage,
});
